<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center py-0">Service Requests</h3>
          <v-card>
            <v-card-text>
              <form @submit.prevent="downloadReport">
                <v-layout wrap>
                  <v-flex xs6 class="px-1">
                    <date-range-picker v-model="dates" range label="Select Date Range"></date-range-picker>
                  </v-flex>
                </v-layout>
                <v-btn small class="pull-right primary" type="submit" :disabled="!dates && dates.length != 2" :loading="loading">Search
                  <v-icon right>mdi-calendar-search</v-icon>
                </v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table :headers="headers" :items="service_requests">
                <template v-slot:[`item.client.name`]="{ item }">
                  <inertia-link :href="'/clients/' + item.client.id">{{ item.client.name }}</inertia-link>
                </template>
                <template v-slot:[`item.insurance_provider.name`]="{ item }">
                  <inertia-link :href="'/insurance-providers/'" v-if="item.insurance_provider_id">{{ item.insurance_provider.name }}</inertia-link>
                  <span v-else>Cash</span>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ moment(item.created_at).format('lll') }}
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <p class="text-muted">Range from {{ date }} to {{ end_date }}</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Reports'
  const DateRangePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/daterangepicker')

  export default {
    name: 'service_requests',
    layout,
    props: [
      'service_requests',
      'date',
      'type',
      'range',
      'end_date'
    ],
    components: {
      DateRangePicker
    },
    metaInfo () {
      return {
        title: 'Service Requests - Reports',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        report: {
          type: this.type,
          date: this.date
        },
        headers: [
          {
            text: 'Name', value: 'client.name',
          },
          {
            text: 'Age', value: 'client.age-group',
          },
          {
            text: 'Sex', value: 'client.gender',
          },
          {
            text: 'Package', value: 'package_name',
          },
          {
            text: 'Cost (KShs.)', value: 'cost',
          },
          {
            text: 'Payment', value: 'insurance_provider.name',
          },
          {
            text: 'Created', value: 'created_at'
          }
        ],
        loading: false,
        dates: this.range,
      }
    },
    methods: {
      downloadReport () {
        if ((!this.dates || this.dates.length != 2)) {
          return
        }
        var query = '?range=' + this.dates
        this.loading = true
        this.$inertia.visit('/reports/service_requests' + query,  {
          preserveState: true,
          preserveScroll: true,
          onFinish: () => {
            this.loading = false
          }
        })
      }
    },
    watch: {
      'report.type': function (value) {
        this.report.date = ''
      },
      'dates': 'downloadReport'
    }
  }
</script>
